export const TERMINAL_SYNC_TASK_STATUSES = ["SUCCESS", "FAILURE", "REJECTED", "REVOKED"]

export const getSyncTaskStatus = (task) => task?.state || task?.data?.status || task?.status || null

export const isTerminalSyncTaskStatus = (status) => TERMINAL_SYNC_TASK_STATUSES.includes(status)
